import * as Redux from 'redux';
import logger from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

import Logging from '~app/core/logging';

import biomeDetailsReducer from './store/biomeDetailsReducer';
import busyReducer from './store/busyReducer';
import cacheReducer from './store/cacheReducer';
import creditsReducer from './store/creditsReducer';
import databaseReducer from './store/databaseReducer';
import errorMiddleware from './store/errorMiddleware';
import errorReducer from './store/errorReducer';
import favoritesReducer from './store/favoritesReducer';
import globeReducer from './store/globeReducer';
import initReducer from './store/initReducer';
import layerReducer from './store/layerReducer';
import searchReducer from './store/searchReducer';
import vectorReducer from './store/vectorReducer';
import wildlifeReducer from './store/wildlifeReducer';
import indexedReducer from './store/indexedReducer';

const log = Logging.getLogger('app.actionLog');

function makeRootReducer() {
  return Redux.combineReducers({
    biomeDetails: biomeDetailsReducer,
    busy: busyReducer,
    cache: indexedReducer(cacheReducer, ['cell-data', 'wildlife-species', 'wildlife-images']),
    credits: creditsReducer,
    database: databaseReducer,
    error: errorReducer,
    favorites: favoritesReducer,
    globe: globeReducer,
    init: initReducer,
    layer: layerReducer,
    search: searchReducer,
    vector: vectorReducer,
    wildlife: indexedReducer(wildlifeReducer, ['main', 'compare']),
  });
}

function createStore(initialState) {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [
    thunkMiddleware,
  ];

  // enable the logger if TRACE level is available
  // logging must be last in the middleware stack
  if (log.isEnabledFor(Logging.LOG_LEVELS.TRACE)) {
    middleware.push(logger);
  }

  middleware.push(errorMiddleware);

  // ======================================================
  // Store Enhancers
  // ======================================================
  let composeEnhancers = Redux.compose;
  if (process.env.NODE_ENV !== 'production') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || Redux.compose;
  }

  // ======================================================
  // Store Instantiation
  // ======================================================
  const store = Redux.createStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(
      Redux.applyMiddleware(...middleware),
    )
  );

  return store;
}

export default createStore;



// WEBPACK FOOTER //
// ./src/createStore.js